"use strict";

(function (global) {

  /**
  * Фабрика отчетов.
  * Предоставлет инструменты для работы с отчетами. Например, для формирования аналитического или интегрированного отчета.
  *
  * @namespace WebAccess.factories.reports
  * @property {OBJECT_TYPE} WebAccess.factories.reports.contentType Тип содержимого фабрики
  * @since 5.0.0.7300
  */

  var Report = WA.FC.BaseFactory.extend({
    className: "ReportFactory",
    contentType: OBJECT_TYPE.REPORT,
    reportName: '',

    init: function (reportName) {
      if (!reportName) {
        WA.raise('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED', 'reportName');
      };
      this.reportName = reportName;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
      * Генерирует отчет
      * @param {Object} [opt_params] параметры отчета
      * @private
      * @method WebAccess.factories.reports.execute
      * @since 5.0.0.7300
      */
    _execute: function (dialog, opt_referenceRecord) {
      var me = this;

      if (opt_referenceRecord) {
        dialog.requisites.integratedReportRefereneceRecordId = opt_referenceRecord.id;
        dialog.requisites.integratedReportRefereneceCode = opt_referenceRecord.referenceName;
      }

      var proxyCall = $.Deferred();

      me.fire(me['class'].EVENT.BEFORE_EXECUTING, me);

      WA.SRV.call("/Report.asmx/Generate", { ReportName: me.reportName, SerializedForm: dialog }).done(function (guid) {
        var deprecatedObject = {
          download: function () {
            var url = new WA.URL('/download.ashx');
            url.setParam('accesstype', 'private');
            url.setParam('id', guid);
            url.setParam('name', me.reportName);
            url.open();
          },

          openByAgent: function () {
              RequestToken(TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY, function (token) {
              var requestParams = {
                id: guid,
                Token: token,
                Repository: "FileSystem",
                DownloadTool: "Handler",
                loc: document.location.host,
                secure: (document.location.protocol == 'http:' ? 'n' : 'y'),
                name: me.reportName
              };
              WA.agent.transmitRequest("opendocument", "edmsplugin", requestParams).fail(function (response) {
                ShowError(response.message);
              });
            });
          },

          open: function () {
            var self = this;
            if (WA.agent.isAvailable()) {
              WA.agent.isPluginAvailable("edmsplugin").always(function (isAvailableResponse) {

                if (isAvailableResponse) {
                  self.openByAgent();
                } else {
                  self.download();
                }
              });
            } else {
              self.download();
            }
          }
        };

        proxyCall.resolve(deprecatedObject);
      }).fail(function (ex) {
        if (!ex) ex = L('ERROR_WHILE_GENERATING_REPORT');

        proxyCall.reject(ex);
      });

      return proxyCall;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сформировать отчет.
    *
    * @method WebAccess.factories.reports.execute
    * @param {Object|WebAccess.components.dialogs.FormDialog} [opt_params] Параметры отчета или экземпляр диалога для копирования реквизитов диалога в параметры сценария.
    * @return {deferred} Специальный deferred-объект.
    * @since 5.0.0.7300
    *
    * @example <caption>Запустить отчет и открыть его в новом окне.</caption>
    * WebAccess.factories.reports("WATestTest").execute({Работник: 123213}).done(function(report) {
    *   report.open();
    * });
    */
    execute: function (opt_params) {
      return this._execute(this._getParams(opt_params));
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сформировать интегрированный отчет.
    *
    * @method WebAccess.factories.reports.executeIntegrated
    * @param {WA.Link} [referenceRecord] Ссылка на объект записи справочника
    * @param {Object|WebAccess.components.dialogs.FormDialog} [opt_params] Параметры отчета или экземпляр диалога для копирования реквизитов диалога в параметры сценария.
    * @return {deferred} Специальный deferred-объект.
    * @since 5.0.0.7300
    *
    * @example <caption>Запустить интегрированный отчет «Использование записи справочника» из справочника «Поручения по РКК».</caption>
    * var referenceRecord =  new WA.Link(132632,OBJECT_TYPE.REFERENCE_RECORD, 'RRCAssignments');
    * WebAccess.factories.reports('Использование записи справочника').executeIntegrated(referenceRecord).done(function(report) {
    *   report.open();
    * }).fail(function(error) {
    *   alert(error);
    * });
    */
    executeIntegrated: function (referenceRecord, opt_params) {
      if (!!referenceRecord
          && referenceRecord.className == 'Link'
          && referenceRecord.type === OBJECT_TYPE.REFERENCE_RECORD) {

        return this._execute(this._getParams(opt_params), referenceRecord);
      } else {
        WA.raise('ERROR_INVALID_PARAMETER', referenceRecord);
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сформировать отчет с предварительным показом диалога.
    *
    * @method WebAccess.factories.reports.showDialogAndExecute
    * @param {String} [dialogName] Имя диалога.
    * @return {deferred} Специальный deferred-объект.
    * @since 5.0.0.1900
    *
    * @example <caption>Запустить отчет и открыть его в новом окне.</caption>
    * WebAccess.factories.reports("WATestTest").execute('DialogName').done(function(report) {
    *   report.open();
    * });
    */
    showDialogAndExecute: function (dialogName, opt_isModal) {
      var me = this;
      var def = $.Deferred();
      me._showDialog(dialogName, opt_isModal).done(function (dialog) {
        me.execute(dialog).done(function (report) {
          def.resolve(report);
        }).fail(function (error) {
          def.reject(error);
        });
      }).fail(function () {
        def.reject(DIALOG_ACTION.CANCEL);
      });
      return def.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сформировать интегрированный отчет.
    *
    * @method WebAccess.factories.reports.showDialogAndExecuteIntegrated
    * @param {WA.Link} [referenceRecord] Ссылка на объект записи справочника.
    * @param {String} [dialogName] Имя диалога.
    * @return {deferred} Специальный deferred-объект.
    * @since 5.0.0.1900
    *
    * @example <caption>Запустить интегрированный отчет «Использование записи справочника» из справочника «Поручения по РКК».</caption>
    * var referenceRecord =  new WA.Link(132632,OBJECT_TYPE.REFERENCE_RECORD, 'RRCAssignments');
    * WebAccess.factories.reports('Использование записи справочника').showDialogAndExecuteIntegrated(referenceRecord, 'DialogName').done(function(report) {
    *   report.open();
    * }).fail(function(error) {
    *   alert(error);
    * });
    */
    showDialogAndExecuteIntegrated: function (referenceRecord, dialogName, opt_isModal) {
      var me = this;
      var def = $.Deferred();
      me._showDialog(dialogName, opt_isModal).done(function (dialog) {
        me.executeIntegrated(referenceRecord, dialog).done(function (report) {
          def.resolve(report);
        }).fail(function (error) {
          def.reject(error);
        });
      }).fail(function () {
        def.reject(DIALOG_ACTION.CANCEL);
      });
      return def.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отображает диалог.
    *
    * @method WebAccess.factories.reports._showDialog
    * @private
    * @since 5.0.0.1900
    */
    _showDialog: function (dialogName, opt_isModal) {
      var def = $.Deferred();
      var me = this;

      if (dialogName) {
        // Отображение диалога.
        WA.FC.dialogs.getObjectByName(dialogName, MODEL.FULL).done(function (dialog) {
          if (opt_isModal === false)
            dialog.modal = false;

          dialog.show();
          dialog.setTitle(L('REPORT_ASKABLE_PARAMS'));

          dialog.bind(WA.CMP.dialogs.FormDialog.EVENT.AFTER_ACTION, function (dialogActionName, result) {
            if (dialogActionName === DIALOG_ACTION.OK) {
              def.resolve(dialog);
            } else {
              me.fire(me['class'].EVENT.ABORT_FILLING_PARAMS, me);
            }
          });
        });
      } else {
        def.resolve(null);
      }
      return def.promise();
    },

    /**
    * Сформировать отчет с предварительным запросом параметров.
    *
    * @method WebAccess.factories.reports.queryParamsAndExecute
    * @param {Object|WebAccess.components.dialogs.FormDialog} [opt_params] Параметры отчета или экземпляр диалога для копирования реквизитов диалога в параметры сценария.
    * @return {deferred} Специальный deferred-объект.
    * @since 5.2.0.1931-beta
    */
    queryParamsAndExecute: function (opt_isModal) {
      var me = this;
      var def = $.Deferred();

      me._queryParams(null, opt_isModal).done(function (dialog) {
        me._execute(dialog).done(function (report) {
          def.resolve(report);
        }).fail(function (ex) {
          def.reject(ex);
        });
      }).fail(function (ex) {
        def.reject(ex);
      });

      return def.promise();
    },

    /**
    * Сформировать интегрированный отчет с предварительным запросом параметров.
    *
    * @method WebAccess.factories.reports.queryParamsAndExecuteIntegrated
    * @param {WA.Link} [referenceRecord] Ссылка на объект записи справочника.
    * @param {Object|WebAccess.components.dialogs.FormDialog} [opt_params] Параметры отчета или экземпляр диалога для копирования реквизитов диалога в параметры сценария.
    * @return {deferred} Специальный deferred-объект.
    * @since 5.2.0.1931-beta
    */
    queryParamsAndExecuteIntegrated: function (referenceRecord, opt_isModal) {
      if (!!referenceRecord
        && referenceRecord.className === 'Link'
        && referenceRecord.type === OBJECT_TYPE.REFERENCE_RECORD) {

        var me = this;
        var def = $.Deferred();

        me._queryParams(referenceRecord, opt_isModal).done(function (dialog) {
          me._execute(dialog, referenceRecord).done(function (report) {
            def.resolve(report);
          }).fail(function (ex) {
            def.reject(ex);
          });
        }).fail(function (ex) {
          def.reject(ex);
        });

        return def.promise();
      } else {
        WA.raise('ERROR_INVALID_PARAMETER', referenceRecord);
        return null;
      };
    },

    /**
     * Заполнить параметры в соответствии с настройками веб-модуля (из даилога, из xml).
     * @return {Deferred} Специальный deferred-объект.
     * @since 5.2.0.1931-beta
     */
    _queryParams: function (opt_referenceRecord, opt_isModal) {
      var def = $.Deferred();
      var me = this;

      WA.SRV.call("/report.asmx/GetReportDialogName", { ReportName: me.reportName }).done(function (res) {
        if (res && res.length > 0) {
          me._showDialog(res, opt_isModal).done(function (dialog) {
            def.resolve(me._getParams(dialog));
          }).fail(function (ex) {
            def.reject(ex);
          });
        } else {
          me._queryParamsFromXml(opt_referenceRecord, opt_isModal).done(function (dialog) {
            def.resolve(me._getParams(dialog));
          }).fail(function (ex) {
            def.reject(ex);
          });
        }
      }).fail(function (ex) {
        def.reject(ex);
      });

      return def.promise();
    },

    /**
     * Заполнить параметры из xml.
     * @return {Deferred} Специальный deferred-объект.
     * @since 5.2.0.1931-beta
     */
    _queryParamsFromXml: function (opt_referenceRecord, opt_isModal) {
      var def = $.Deferred();
      var me = this;
      var params = { name: this.reportName };

      if (opt_referenceRecord) {
        params.id = opt_referenceRecord.id;
        params.refcode = opt_referenceRecord.referenceName;
      }

      // На сервере строится разметка модалки со всеми нужными параметрам.
      WA.SRV.call("/ModalWindow.asmx/Create", {
        ControlName: 'report_params',
        Params: $.toJSON(params)
      }).done(function (res) {

        // Если параметров нет то в классе ReportParams.vb не передается контрол с ИД ReportParamsModalWindow.
        if ($(res.html).find('#ReportParamsModalWindow').length > 0) {
          var dialog = new WA.components.dialogs.ReportParamsDialog({}, {
            FormHtml: res.html,
            // ModalWindow возвращает модалки для многих объектов, а не только для отчетов, а возвращает он объек состоящий из 2 свойств
            // html и initJs. Html нам подходит, а вот в initJs напихано много всего ненужного и он строка, поэтому мы просто добавляем туда нужную
            // нам информаию (описание всех реквизитов) после ключа 'FormData:' и обрезаем строку.
            FormData: res.initJs.substring(res.initJs.indexOf('FormData:') + 9)
          });

          if (opt_isModal === false)
            dialog.modal = false;

          // Если закрыли модалку не по ОК то просто ничего не делаем.
          dialog.bind(dialog['class'].EVENT.AFTER_CLOSE_BY_OK, function () {
            dialog.validateForm();
            def.resolve(dialog);
          });

          dialog.bind(dialog['class'].EVENT.AFTER_CLOSE_BY_CANCEL, function () {
            me.fire(me['class'].EVENT.ABORT_FILLING_PARAMS, me);
          });

          dialog.show();
        } else {
          def.resolve(null);
        }
      }).fail(function (res) {
        def.reject(res);
      });

      return def.promise();
    },

    /**
     * Парсит параметры диалога.
     * @returns {} Сериализованная форма диалога.
     * @since 5.2.0.1931-beta
     */
    _getParams: function (params) {
      var serializeForm = { tables: {}, requisites: {}, details: {} };

      if (params) {
        if (params.className === 'FormDialog' || params.className === 'ReportParamsDialog') {

          serializeForm = params.form.serialize({
            onlyValue: true,
            useRowNumber: true,
            withoutTables: true,
            transformMultiReqsToDetailRows: true
          });
        } else {
          for (var param in params) {
            serializeForm.requisites[param] = params[param];
          }
        }
      }

      return serializeForm;
    }
  }, {
    EVENT: {
      /**
       * Срабатывает перед началом генерации отчета.
       * @event Core.report.EVENT.BEFORE_EXECUTING
       * @since 5.2.0.1931-beta
       */
      BEFORE_EXECUTING: 'beforeExecuting',

      /**
       * Срабатывает при нажатии кнопки "Отмена" в окне запрашиваемых параметров.
       * @event Core.report.EVENT.ABORT_FILLING_PARAMS
       * @since 5.2.0.1934-beta
       */
      ABORT_FILLING_PARAMS: 'abortFillingParams'
    }
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  global.factories.reports = function (reportName) {
    return new Report(reportName);
  };

  global.factories.reports.getReportByName = function (reportName) {
    WA.raise('NOT_IMPLEMENTED');
    return $.Deferred;
  };

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess);